import React from 'react';
import { CheckCircle2, AlertTriangle, MousePointerClick } from 'lucide-react';
import { PAPERS } from '@/lib/bracket/paper';

export const BracketStatus = ({ layout, nameFs, settings, update, editable }) => {
  const fs = (nameFs || layout.M.fs) * layout.scale;
  const n = layout.pageCount;
  const small = fs < 6.5;
  const paper = `${PAPERS[layout.page.paper].label} ${layout.page.orientation}`;
  const text = `${n === 1 ? 'Fits on 1' : `Split across ${n}`} ${paper} page${n > 1 ? 's' : ''} · ${fs.toFixed(1)} pt text`;
  const chip = small ? 'bg-amber-50 text-amber-800 border-amber-200' : 'bg-emerald-50 text-emerald-800 border-emerald-200';
  const quick = 'text-xs font-semibold underline underline-offset-2 hover:text-amber-950';
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 mt-3" data-testid="bracket-status">
      <div className={`inline-flex flex-wrap items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold ${chip}`}>
        {small ? <AlertTriangle className="w-3.5 h-3.5" /> : <CheckCircle2 className="w-3.5 h-3.5" />}
        <span data-testid="bracket-fit-summary">{text}</span>
        {small && settings.paper === 'letter' && (
          <button type="button" className={quick} onClick={() => update({ paper: 'tabloid' })} data-testid="bracket-quick-tabloid">Use Tabloid</button>
        )}
        {small && Number(settings.pages) === 1 && layout.mode !== 'consolation' && (
          <button type="button" className={quick} onClick={() => update({ pages: 2 })} data-testid="bracket-quick-2pages">Split to 2 pages</button>
        )}
      </div>
      {editable && (
        <span className="inline-flex items-center gap-1.5 text-xs text-slate-500">
          <MousePointerClick className="w-3.5 h-3.5" />Click any game to enter its score
        </span>
      )}
    </div>
  );
};
